import { render, staticRenderFns } from "./AddCouponDialog.vue?vue&type=template&id=9f88d3d0&scoped=true"
import script from "./AddCouponDialog.vue?vue&type=script&lang=js"
export * from "./AddCouponDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCouponDialog.vue?vue&type=style&index=0&id=9f88d3d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f88d3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f88d3d0')) {
      api.createRecord('9f88d3d0', component.options)
    } else {
      api.reload('9f88d3d0', component.options)
    }
    module.hot.accept("./AddCouponDialog.vue?vue&type=template&id=9f88d3d0&scoped=true", function () {
      api.rerender('9f88d3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/package/modules/AddCouponDialog.vue"
export default component.exports